import React from 'react';

import { WaffleItem, WaffleItemProps } from '@lumapps/waffle/components/Waffle/WaffleItem/WaffleItem';

type CustomizationBookmarkProps = WaffleItemProps | { bookmarks: WaffleItemProps[] };

/**
 * Customization bookmark that wraps the Bookmark component.
 * Accepts either a single flat bookmark (title/link/icon) or a `bookmarks` array to render several at once.
 * @param props - CustomizationBookmarkProps
 * @returns CustomizationBookmark
 */
export const CustomizationBookmark: React.FC<CustomizationBookmarkProps> = (props) => {
    if ('bookmarks' in props) {
        const { bookmarks } = props;

        if (!Array.isArray(bookmarks)) {
            // eslint-disable-next-line no-console
            console.warn('CustomizationBookmark: `bookmarks` prop must be an array, got', bookmarks);
            return null;
        }

        return (
            <>
                {bookmarks.map((bookmark, index) => (
                    <WaffleItem key={bookmark.id ?? index} {...bookmark} />
                ))}
            </>
        );
    }

    return <WaffleItem {...props} />;
};

CustomizationBookmark.displayName = 'CustomizationBookmark';
